import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "./components/Landing";
import Header from "./components/Header";
import Products from "./components/Products";
import Collection2 from "./components/Collection2";
import ProductDetails from "./components/ProductDetails";
import Basket from "./components/Basket";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import Success from "./components/Success";
import Failed from "./components/Failed";
import About from "./components/About";
import Return from "./components/Return";

const CART_KEY = 'my_shop_cart'

function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])
  return null
}

function App() {
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [cartItems, setCartItems] = useState(() => {
    try {
      const saved = localStorage.getItem(CART_KEY)
      return saved ? JSON.parse(saved) : []
    } catch {
      return []
    }
  })
  const [searchText, setSearchText] = useState('')

  useEffect(() => {
    try {
      localStorage.setItem(CART_KEY, JSON.stringify(cartItems))
    } catch {}
  }, [cartItems])

  const addToCart = (product) => {
    setCartItems(prev => {
      const existing = prev.find(item => item.id === product.id)
      if (existing) {
        return prev.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      }
      return [...prev, { ...product, quantity: 1 }]
    })
  }

  const cartCount = cartItems.reduce((sum, item) => sum + item.quantity, 0)

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="App">
        <Header
          onCategorySelect={setSelectedCategory}
          selectedCategory={selectedCategory}
          cartCount={cartCount}
          onSearch={setSearchText}
        />
        <Routes>
          <Route path="/" element={
            <>
              <Landing />
              <Collection2 />
              <Products
                selectedCategory={selectedCategory}
                addToCart={addToCart}
                searchText={searchText}
              />
            </>
          } />
          <Route path="/product/:id" element={<ProductDetails addToCart={addToCart} />} />
          <Route path="/basket" element={<Basket cartItems={cartItems} setCartItems={setCartItems} />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/success" element={<Success />} />
          <Route path="/failed" element={<Failed />} />
          <Route path="/about" element={<About />} />
          <Route path="/return" element={<Return />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App;